import { Stack } from "@mui/material";
import { Input, Button, Image } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import { memo, useCallback, useEffect, useState } from "react";
import { useOpen } from "../../../hooks";
import { CameraComponentExporBananas } from "./camera-component";
import noImg from "../../../../images/no-image.png";

const { TextArea } = Input;

interface ValidationTextAreaProps {
  textStore: string;
  setTextStore: (value: string) => void;
  foto: string;
  setFoto: (value: string) => void;
  isVideo: boolean;
}

export const ValidationTextArea = memo(
  ({ textStore, setTextStore, foto, setFoto, isVideo }: ValidationTextAreaProps) => {
    const [showCamera, setShowCamera] = useState(false);
    const [continuoCamera, setContinuoCamera] = useState(false);
    const { open, handleClose, handleOpen } = useOpen();

    useEffect(() => {
      if (continuoCamera) {
        setContinuoCamera(false);
        handleOpen();
      }
    }, [continuoCamera, handleOpen]);

    const onClose = useCallback(() => {
      setShowCamera(false);
      handleClose();
    }, [handleClose]);

    const handleOpenCamera = useCallback(() => {
      setShowCamera(true);
      setContinuoCamera(true);
    }, []);

    const handleTextChange = useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextStore(e.target.value);
      },
      [setTextStore]
    );

    return (
      <>
        <Stack direction="column" spacing={1}>
          <TextArea
            rows={4}
            value={textStore}
            onChange={handleTextChange}
            placeholder="Indique cual es el Error!!"
            maxLength={200}
            count={{
              show: true,
              max: 200,
            }}
          />

          {!isVideo && (
            <Stack direction="row" spacing={1}>
              <Button
                size="large"
                onClick={handleOpenCamera}
                icon={<CameraOutlined />}
              />
              <Image
                src={foto === "" ? noImg : foto}
                style={{
                  marginTop: "2.5px",
                  width: 36,
                  height: 36,
                  borderRadius: 5,
                  boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
                }}
              />
            </Stack>
          )}
        </Stack>

        {showCamera && (
          <CameraComponentExporBananas
            open={open}
            handleClose={onClose}
            setFoto={setFoto}
          />
        )}
      </>
    );
  },
  // Comparación personalizada
  (prevProps, nextProps) => {
    return (
      prevProps.textStore === nextProps.textStore &&
      prevProps.foto === nextProps.foto &&
      prevProps.isVideo === nextProps.isVideo
    );
  }
);

ValidationTextArea.displayName = "ValidationTextArea";